import React from 'react';
import { ReportRenderer, Contents } from '@cloudclevr/components';
import type { ReportDocument } from '@cloudclevr/components';

interface ReportV2PreviewProps {
  document: ReportDocument;
  rendererRef?: React.RefObject<HTMLDivElement>;
}

export const ReportV2Preview: React.FC<ReportV2PreviewProps> = ({ document, rendererRef }) => {
  return (
    <div className="flex flex-1 min-h-0 bg-interfaceColor-5 pl-2 gap-5">
      <div className="flex-shrink-0 overflow-y-auto my-4 pl-0 ml-6">
        <Contents template={document.template} scrollOffset={0} />
      </div>
      <div ref={rendererRef} className="flex-1 min-w-0 overflow-y-auto pl-5 my-4">
        <ReportRenderer document={document} />
      </div>
    </div>
  );
};
